<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>文章列表</h3>
      <el-form
        :model="searchForm"
        size="mini"
        label-width="120px"
        @submit.native.prevent
        :inline="true"
      >
        <el-form-item label="域名">
          <!-- <el-input
            type="text"
            v-model="searchForm.domain"
            placeholder="请输入域名"
          ></el-input> -->
          <el-select v-model="searchForm.domain" clearable>
            <el-option
              v-for="(item, index) in domainList"
              :label="item.dm"
              :value="item.dm"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题">
          <el-input
            type="text"
            v-model="searchForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="danger" size="mini" @click="getList(searchForm)"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <el-table :data="articleList" v-loading="loading" style="width: 100%">
        <el-table-column
          prop="customerName"
          label="所属客户"
          align="center"
          width="100px"
        ></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="writer" label="作者" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <el-table-column label="分类" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.categories ? scope.row.categories.join(",") : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="链接" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.urls.length" :href="scope.row.urls[0].url" target="_blank"
              >链接一</a
            >
            <a
              v-if="scope.row.urls2.length"
              :href="scope.row.urls2[0].url"
              target="_blank"
              >链接二</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="380px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="checkContent(scope.row.id)"
              >更新内容</el-button
            >
            <!-- <el-button type="success" size="mini">更新内容</el-button> -->
            <el-button type="danger" size="mini" @click="deleteArticle(scope.row.id)"
              >删除文章</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      articleList: [],
      searchForm: {
        currentPage: 1,
        customerId: "",
        endTime: "",
        pageSize: 20,
        startTime: "",
        status: "",
        domain: "",
        title: "",
      },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      domainList: [],
    };
  },
  methods: {
    async getList(params) {
      this.loading = true;
      await axiosGet("/api/cms/article/list", params).then((res) => {
        if (res.code == 0) {
          this.articleList = res.data.records;
          this.currentPage = 1;
          this.pageSize = 20;
          this.total = res.data.total;
        }
      });
      this.loading = false;
    },
    handleCurrentChange(currentPage) {
      this.searchForm.currentPage = currentPage;
      this.getList(this.searchForm);
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getList(this.searchForm);
    },
    checkContent(id) {
      //axiosGet("/api/cms/article/content", { id: id }, "JSON").then((res) => {});
      this.$router.push({ path: "/aiArticle", query: { id: id } });
    },
    deleteArticle(id) {
      this.$confirm("此操作将永久删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/cms/article/delete", { ids: [id] }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "删除成功", type: "success" });
              this.getList(this.searchForm);
            }
          });
        })
        .catch(() => {
          this.$message({ message: "已取消删除", type: "info" });
        });
    },
  },
  mounted() {
    this.getList(this.searchForm);

    axiosGet("/api/cms/article/domains").then((res) => {
      if (res.code == 0) {
        this.domainList = res.data.length ? res.data : [];
      }
    });
  },
};
</script>

<style>
a {
  color: #02ffb2;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ArticleManager/articleList.vue